import { useState } from 'react';
import { Container } from './styled';
import { Charts, ChartFull } from '../../../../../components';
import { GiResize } from "react-icons/gi";

export function Chart({ data, visionType }) {

    const [openFullChart, setOpenFullChart] = useState(false);

    const objKey = () => {
        const key = {
            'M': 'mes',
            'W': 'indice',
            'D': 'indice'
        };
        return key[visionType]
    }

    const generateChartData = (userData) => {
        const groupByKey = (key) => {
            return userData.reduce((accumulator, item) => {
                accumulator.push(item[key]);
                return accumulator;
            }, []);
        };
        const chartData = {
            labels: groupByKey(objKey()),
            datasets: [
                {
                    label: 'Atendimentos',
                    data: groupByKey('total_atendimentos'),
                    backgroundColor: 'rgba(75, 192, 192, 1)',
                    borderColor: 'rgba(75, 192, 192, 1)',
                    borderWidth: 2,
                    fill: false,
                },
                {
                    label: 'Clientes Atendidos',
                    data: groupByKey('total_clientes'),
                    backgroundColor: 'rgba(255, 99, 132, 1)',
                    borderColor: 'rgba(255, 99, 132, 1)',
                    borderWidth: 2,
                    fill: false,
                },
            ],
        };
        return chartData;
    };

    return (
        <>
            <Container>
                <div className='full--'>
                    <span onClick={() => setOpenFullChart(true)}>
                        <GiResize fontSize={'1.75rem'} />
                    </span>
                </div>
                <div className='--chart'>
                    <Charts
                        type='Line'
                        data={generateChartData(data)}
                    />
                </div>
            </Container >
            {(openFullChart) &&
                (<ChartFull
                    onClose={() => setOpenFullChart(false)}
                    title={`Total de atendimentos e clientes`}
                    dataChart={
                        {
                            type: "Line",
                            data: generateChartData(data)
                        }
                    }
                />)
            }
        </>

    );
}
